function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelLocationMap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "travel_x5F_location_x5F_map",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.361 32",
    style: {
      enableBackground: "new 0 0 32.361 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "32.361,32 0,32 2.333,18 6.181,18 6.181,20 4.028,20 2.361,30 30,30 28.333,20 26.181,20  26.181,18 30.028,18  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M16.181,14c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S18.386,14,16.181,14z M16.181,8 c-1.103,0-2,0.897-2,2s0.897,2,2,2s2-0.897,2-2S17.284,8,16.181,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M16.18,27.814L7.396,14.502C6.589,13.09,6.181,11.553,6.181,10c0-5.514,4.486-10,10-10 s10,4.486,10,10c0,1.575-0.487,3.382-1.211,4.496c-0.591,0.909-7.955,12.055-7.955,12.055L16.18,27.814z M16.181,2 c-4.411,0-8,3.589-8,8c0,1.206,0.317,2.401,0.918,3.456l7.082,10.729c1.944-2.943,6.645-10.061,7.112-10.779 c0.441-0.679,0.888-2.067,0.888-3.406C24.181,5.589,20.592,2,16.181,2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelLocationMap);
export default __webpack_public_path__ + "static/media/travel_location_map.f269d17e06a3c85e46b8bd604ec2b587.svg";
export { ForwardRef as ReactComponent };